import Swiper, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';


document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.news-swiper', {
      modules: [Navigation],
      direction: 'horizontal',
      slidesPerView: 1.3,
      spaceBetween: 10,
      loop: true,
      breakpoints: {
        640: {
          slidesPerView: 1.5,
          spaceBetweenSlides: 10
        },
        1024: {
            slidesPerView: 2.5,
            spaceBetweenSlides: 10
        },
        1280: {
          slidesPerView: 3.5,
          spaceBetweenSlides: 10
        },
      },
      navigation: {
        nextEl: '.swiper-custom-next',
      },
    });
  })
